module.exports = __webpack_public_path__ + "static/media/border-bottom.69fe3ade.svg";